export const SCHEDULE_COLOR_OPTIONS = ['#E94934', '#FFD92B', '#FFA40D', '#3B82F6', '#10B981', '#8B5CF6'];

const SCHEDULE_BG_BY_COLOR = {
  '#E94934': '#FDECEA',
  '#FFD92B': '#FFF8D5',
  '#FFA40D': '#FFF3E0',
  '#3B82F6': '#EBF3FF',
  '#10B981': '#EAFBF5',
  '#8B5CF6': '#F1EAFF',
};

export const DEFAULT_SCHEDULE_COLOR = SCHEDULE_COLOR_OPTIONS[0];

function clampChannel(value) {
  return Math.max(0, Math.min(255, Math.round(value)));
}

export function getScheduleAccentBackground(color, opacity = 0.14) {
  if (!color || typeof color !== 'string') return `rgba(233, 73, 52, ${opacity})`;
  if (SCHEDULE_BG_BY_COLOR[color]) return SCHEDULE_BG_BY_COLOR[color];

  const hex = color.replace('#', '');
  const normalized = hex.length === 3
    ? hex.split('').map((char) => char + char).join('')
    : hex;

  if (!/^[0-9a-fA-F]{6}$/.test(normalized)) return `rgba(233, 73, 52, ${opacity})`;

  const r = clampChannel(parseInt(normalized.slice(0, 2), 16));
  const g = clampChannel(parseInt(normalized.slice(2, 4), 16));
  const b = clampChannel(parseInt(normalized.slice(4, 6), 16));
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

export function normalizeScheduleColor(value) {
  return value || DEFAULT_SCHEDULE_COLOR;
}
